module.exports = __webpack_public_path__ + "img/danos_materiales.69d7ab64.svg";